import axios from "../../utils/axios";
async function create(data) {
  return await axios.post("single/promotions", data);
}

async function fetchList(params) {
  return await axios.get("single/promotions", { params });
}

async function fetch(id) {
  return await axios.get(`single/promotions/${id}`);
}

async function update(id, data) {
  return await axios.patch(`single/promotions/${id}`, data);
}

async function remove(id) {
  return await axios.delete(`single/promotions/${id}`);
}

export const promotionService = {
  create,
  fetchList,
  fetch,
  update,
  remove,
};
